module.exports = __webpack_public_path__ + "img/세이지.712d9af6.png";